<template>
  <div style="height: 100%; width: 100%">
    <iframe
      width="100%"
      height="100%"
      style="border:0"
      Loading="lazy"
      allowfullscreen
      :src="googleMapDirection"
    />
  </div>
</template>

<script>
export default {
  name: 'MapComponent',

  props: {
    place: {
      type: Array,
      required: true,
    },
    bookingStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      center: { lat: -34.6015, lng: -58.3855 },
      currentPlaceMarker: {},
      directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${this.place[0]},${this.place[1]}`,
      maxZoom: this.bookingStatus === 'pending' ? 16 : 18,
      mapStyles:
                  [
                    {
                      featureType: 'poi.business',
                      stylers: [
                        {
                          visibility: 'off',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.medical',
                      stylers: [
                        {
                          visibility: 'simplified',
                        },
                        {
                          weight: 1.5,
                        },
                      ],
                    },
                    {
                      featureType: 'poi.medical',
                      elementType: 'labels',
                      stylers: [
                        {
                          color: '#78909c',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.medical',
                      elementType: 'labels.text',
                      stylers: [
                        {
                          visibility: 'off',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.park',
                      elementType: 'labels.text',
                      stylers: [
                        {
                          visibility: 'off',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.place_of_worship',
                      stylers: [
                        {
                          visibility: 'simplified',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.school',
                      stylers: [
                        {
                          visibility: 'off',
                        },
                      ],
                    },
                    {
                      featureType: 'poi.sports_complex',
                      stylers: [
                        {
                          visibility: 'off',
                        },
                      ],
                    },
                  ],
    };
  },

  computed: {

    googleMapDirection() {
      let url = '';
      if (this.bookingStatus === 'pending' || this.bookingStatus === 'cancelled') {
        url = `https://www.google.com/maps/embed/v1/view?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&zoom=18&center=${this.place[0]},${this.place[1]}`;
      } else {
        url = `https://www.google.com/maps/embed/v1/place?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&q=${this.place[0]},${this.place[1]}`;
      }
      return (url);
    },

  },

  watch: {
    place() {
      this.addPlaceMarker();
    },
  },

  mounted() {
    this.addPlaceMarker();
    this.stores = this.storesList;
  },

  methods: {

    addPlaceMarker() {
      if (this.place) {
        this.currentPlaceMarker = null;
        this.currentPlaceMarker = {
          lat: parseFloat(this.place[0]),
          lng: parseFloat(this.place[1]),
        };
        this.center = this.currentPlaceMarker;
      }
    },
  },
};
</script>
